<template>
  <div class="reportWrapper">
    <template v-if="jsonReady">
      <div class="report-component" id="tr-leading-indicators-html">
        <p class="announcement-date">
          {{ helpJsonContent.executive_summary.author }}
        </p>

        <div
          class="margin-top--quarter margin-bottom--quarter background-blue inner-padding--half font-white intro rounded-corners-10"
        >
          <em>{{ helpJsonContent.executive_summary.call_out.quote_white }}</em>
        </div>

        <template
          v-for="(value, index) in helpJsonContent.executive_summary.content"
          :key="index"
        >
          <template v-if="index.includes('section_title')">
            <h4 class="margin-top">{{ value }}</h4>
          </template>

          <template v-if="index.includes('body')">
            <p v-html="value"></p>
          </template>

          <template v-if="index.includes('bullet_list')">
            <ul>
              <template v-for="bullet in value" :key="bullet">
                <li>{{ bullet }}</li>
              </template>
            </ul>
          </template>

          <template v-if="index.includes('image')">
            <p v-bind:key="index" class="text-center max-width-1000">
              <img
                :src="images_path + value.attributes.href"
                alt="TR Executive Summary Report Image"
              />
            </p>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
  import moment from 'moment';
  import _ from 'lodash';
  export default {
    props: {
      content: {
        type: String,
        required: false,
      },
      imagespath: {
        type: String,
        required: false,
      },
      issue: {
        type: String,
        required: false,
      },
      fromTr: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        parsed: {},
        jsonReady: true,
        summary: '',
        images_path: this.imagespath,
        jsonContent: JSON.parse(this.content),
      };
    },
    computed: {
      helpJsonContent: function () {
        //return JSON.parse(this.content.replace("\\u2029 | \\u2028", "<br>"));
        return JSON.parse(this.content);
      },
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
      getKey: function (object_path) {
        var keyExists = _.get(this.jsonContent, object_path, 0);

        if (keyExists !== 0) {
          return true;
        }
        return false;
      },
      parseJson: function () {
        this.jsonReady = true;
      },

      convertToHyphens: function (value) {
        return value.replace(/_/g, '-');
      },
    },
  };
  //https://stackoverflow.com/questions/13869627/unable-to-access-json-property-with-dash  jsonObj.profile - id
  //To access a key that contains characters that cannot appear in an identifier, use brackets: jsonObj["profile-id"]
</script>
